import React from 'react';
import { ArrowUp, ArrowDown, Trash2, Languages, Loader2, ChefHat } from 'lucide-react';

const DIETS = ['L', 'G', 'V'];
const inputCls = 'w-full bg-white text-gray-900 border border-gray-300 rounded-md px-2 py-1.5 text-sm focus:outline-none focus:border-amber-500';

const LangFields = ({ dish, field, onChange, testPrefix, textarea }) => {
  const Tag = textarea ? 'textarea' : 'input';
  return (
    <div className="grid md:grid-cols-3 gap-2">
      {[['', 'EN'], ['Fi', 'FI'], ['Sv', 'SV']].map(([suffix, label]) => (
        <label key={label} className="text-[11px] text-gray-500">
          {label}
          <Tag
            rows={textarea ? 2 : undefined}
            className={inputCls}
            value={dish[`${field}${suffix}`] || ''}
            onChange={(e) => onChange({ [`${field}${suffix}`]: e.target.value })}
            data-testid={`${testPrefix}-${field}${suffix.toLowerCase() || 'en'}`}
          />
        </label>
      ))}
    </div>
  );
};

export const DishRow = ({ dish, index, total, compact, translating, onChange, onMove, onDelete, onTranslate, testPrefix }) => {
  const toggleDiet = (d) => {
    const cur = dish.dietary || [];
    const dietary = cur.includes(d) ? cur.filter((x) => x !== d) : DIETS.filter((x) => cur.includes(x) || x === d);
    onChange({ dietary, vegan: dietary.includes('V') });
  };

  return (
    <div className="border border-gray-200 rounded-lg p-3 bg-white space-y-2" data-testid={testPrefix}>
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs font-bold text-gray-400 w-6">{index + 1}.</span>
        {DIETS.map((d) => (
          <button key={d} type="button" onClick={() => toggleDiet(d)} data-testid={`${testPrefix}-diet-${d}`}
            className={`text-xs font-bold w-7 h-7 rounded-md border ${(dish.dietary || []).includes(d) ? 'bg-green-600 text-white border-green-600' : 'bg-white text-gray-500 border-gray-300'}`}>
            {d}
          </button>
        ))}
        {!compact && (
          <button type="button" onClick={() => onChange({ chefPick: !dish.chefPick })} data-testid={`${testPrefix}-chefpick`}
            className={`text-xs font-semibold px-2.5 h-7 rounded-md border inline-flex items-center gap-1 ${dish.chefPick ? 'bg-amber-600 text-white border-amber-600' : 'bg-white text-gray-500 border-gray-300'}`}>
            <ChefHat className="w-3.5 h-3.5" /> Kokin suositus
          </button>
        )}
        <button type="button" onClick={onTranslate} disabled={translating} data-testid={`${testPrefix}-translate`}
          className="text-xs font-semibold px-2.5 h-7 rounded-md bg-indigo-600 text-white inline-flex items-center gap-1 disabled:opacity-60">
          {translating ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Languages className="w-3.5 h-3.5" />} Käännä
        </button>
        <div className="ml-auto flex gap-1">
          <button type="button" disabled={index === 0} onClick={() => onMove(-1)} className="p-1.5 rounded border border-gray-300 disabled:opacity-30" data-testid={`${testPrefix}-up`}><ArrowUp className="w-3.5 h-3.5" /></button>
          <button type="button" disabled={index === total - 1} onClick={() => onMove(1)} className="p-1.5 rounded border border-gray-300 disabled:opacity-30" data-testid={`${testPrefix}-down`}><ArrowDown className="w-3.5 h-3.5" /></button>
          <button type="button" onClick={onDelete} className="p-1.5 rounded border border-red-200 text-red-600 hover:bg-red-50" data-testid={`${testPrefix}-delete`}><Trash2 className="w-3.5 h-3.5" /></button>
        </div>
      </div>
      <LangFields dish={dish} field="name" onChange={onChange} testPrefix={testPrefix} />
      {!compact && <LangFields dish={dish} field="description" onChange={onChange} testPrefix={testPrefix} textarea />}
    </div>
  );
};

export default DishRow;
